export const OrcamentosBuscaEntity ={
    sku:0
    ,qtde:0
    ,ml:true  
}